import React, { CSSProperties, useContext, useEffect, useState } from 'react';
import { hexToRGBA } from 'common/js/colors';
import styles from './index.scss';
import { StoreContext } from '../../../../lib/store';
import { fetchCreative } from '../../../../lib/fetch-creative';
import { Iframe } from 'common/components/iframe';
import eventBus from 'common/event-handling/event-bus.model';
import { logMessage } from 'common/js/sentry';
import { PreloadErrorEvent } from 'common/event-handling/events';

interface Props {
  onClick: (e: ClickEvent) => void;
  shouldRefreshFrameOnRotation: boolean;
  forceResponsiveHtml: boolean;
  displayBlurEffect: boolean;
}

export const CreativeHtml = ({
  onClick,
  shouldRefreshFrameOnRotation,
  forceResponsiveHtml,
  displayBlurEffect
}: Props) => {
  const rootStore = useContext(StoreContext);
  const [srcDoc, setSrcDoc] = useState<string>('');
  const { creative, blurEffect } = rootStore.formatConfig;
  const { isVertical } = rootStore.creativeStore;
  const containerStyle: CSSProperties = {
    backgroundColor: hexToRGBA(
      creative?.backgroundColor || '#000',
      (creative?.backgroundOpacity || 0) / 100
    )
  };

  useEffect(() => {
    (async function() {
      try {
        const html = await fetchCreative(creative.previewUrl, {
          shouldAddBlurEffectStyle:
            displayBlurEffect && blurEffect?.force === true
        });
        setSrcDoc(html);
      } catch (err) {
        logMessage(err as string);
        eventBus.publish(new PreloadErrorEvent());
      }
    })();
  }, []);

  const renderBlurEffect = () => {
    const scale = 1.1 + blurEffect.zoom / 10;
    const style = {
      blurStyle: {
        top: isVertical ? `${blurEffect.offsetY}px` : 0,
        left: !isVertical ? `${blurEffect.offsetX}px` : 0,
        backgroundImage: `url(${blurEffect.image})`,
        transform: `scale(${scale})`
      }
    };

    return (
      <div className={styles.blurContainer}>
        <div style={style.blurStyle} className={styles.blurBackground}></div>
      </div>
    );
  };

  return (
    <div
      id="creative"
      className={styles.htmlCreativeWrapper}
      style={containerStyle}
    >
      {displayBlurEffect && renderBlurEffect()}
      <Iframe
        onClick={onClick}
        srcDoc={srcDoc}
        shouldRefreshFrameOnRotation={shouldRefreshFrameOnRotation}
        forceResponsiveHtml={forceResponsiveHtml}
        injectMRAID={rootStore.injectMRAID}
        supportMRAIDExpand={!rootStore.isInAppOpenAuction}
      />
    </div>
  );
};
